// extracted by mini-css-extract-plugin
export var cardLayout = "_5w-1";
export var paginationContainer = "_5w-0";